import { Injectable, Type, inject } from '@angular/core';

import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { TeamPagesViewModel } from '../teampages-core/team-pages.model';
import { TeamPagesModule } from './team-pages.module';

export interface TeamPagesCompetitionViewBinding {
    teampagesViewModel: TeamPagesViewModel;
    hasCompetitions: boolean;
}

@Injectable({ providedIn: 'root' })
export class TeamPagesComponentLoaderService extends ComponentLoaderService<TeamPagesModule> {
    moduleName = 'TeamPagesModule';

    constructor() {
        const moduleLoader = inject(ModuleLoaderService);
        const loggerFactory = inject(LoggerFactory);

        super(moduleLoader, loggerFactory);
    }

    getTeamPagesComponent(): ComponentProxy<TeamPagesCompetitionViewBinding> {
        return this.getComponentProxy((module) => module.competitionTeamPagesComponent, 'sports-team-pages');
    }

    getModule(): Promise<Type<TeamPagesModule>> {
        return import('./team-pages.module').then((m) => m.TeamPagesModule);
    }
}
